import React, { useEffect, useState, useRef } from 'react';
import RealStoriesSection from '../components/RealStoriesSection';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import Button from '@mui/material/Button';
import VerifiedIcon from '@mui/icons-material/Verified';
import SendIcon from '@mui/icons-material/Send';
import API_BASE_URL from '../config';
// import OutstandingStatsSection from '../components/OutstandingStatsSection';
import disposableDomains from '../utils/disposableDomains';
import { motion } from 'framer-motion';
import '../Styles/button.css';

function Home() {
  useEffect(() => {
    document.title = 'Home | Outstanding Workplaces';
  }, []);

  const [form, setForm] = useState({
    firstName: '', lastName: '', role: '', email: '', mobile: '',
    typeOfCompany: '', companyName: '', hq: '', industry: '', employees: '',
    howDidYouKnow: '', consent: false
  });

  const [emailError, setEmailError] = useState("");
   

  // 🔥 NEW: Dynamic stats
  const stats = [
    { value: "5000+", label: "Professionals Engaged" },
    { value: "200+", label: "Organizations Impacted" },
    { value: "50+", label: "Events & Conferences Hosted" },
    { value: "100+", label: "HR Leaders & Experts Featured" },
    { value: "95%", label: "Client Satisfaction Rate" }
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % stats.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Email validation function using disposableDomains
  const validateEmail = (email) => {
    const parts = email.split("@");
    if (parts.length !== 2) return false;
    const domain = parts[1].toLowerCase();
    return !disposableDomains.includes(domain);
  };

  const navigate = useNavigate();

  // Create a ref for the nomination section
  const nominationRef = useRef(null);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Real-time email validation
    if (name === "email") {
      if (!validateEmail(value)) {
        setEmailError("Please enter your work email address.");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    // Final check before submit
    if (!validateEmail(form.email)) {
      setEmailError("Please enter your work email address.");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/api/nominations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        navigate('/thank-you');
      } else {
        alert('Submission failed: ' + (data.error || 'Unknown error'));
        console.error('Submission error:', data);
      }
    } catch (err) {
      alert('Network or server error. See console for details.');
      console.error('Network/server error:', err);
    }
  };

  // Scroll function for the button
  const scrollToNomination = () => {
    if (nominationRef.current) {
      nominationRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
       <section className="hero">
        <div className="hero-left">
        
<img
  src="/assets/Badge_TM.png"
  alt="Certified 2025"
  className="home-certified-badge"
/>
          <h1>Outstanding Workplaces<br />Certified Organization</h1>
          <h2>The Emerging Benchmark in Workplace Culture</h2>
          <p>
            Outstanding Workplaces Certification is your gateway to amplifying your employer brand, attracting high-performing talent, and fostering an environment where people and performance flourish.
          </p>
          <Button
  variant="contained"
  onClick={scrollToNomination}
  startIcon={<VerifiedIcon className="verified-icon" />}
  className="get-certified-btn"
>
  Get Certified
</Button>
        </div>
        <div className="hero-right">
          <div className="hero-single-image">
            <img
              src="/hero_section_img.png"
              alt="Outstanding Workplaces Hero"
              className="hero-img-single"
            />
          </div>
        </div>
      </section>
      {/* <OutstandingStatsSection /> */}
      <section className="home-blue-section">
        <div className="home-blue-container two-col">
          <h2 className="home-blue-title">
            Join the <br />Outstanding Workplaces Community!
          </h2>
         <div className="home-blue-counter">
  <motion.h1
    key={index}
    initial={{ y: 30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    exit={{ y: -30, opacity: 0 }}
    transition={{ duration: 0.5 }}
    className="counter-value"
  >
    {stats[index].value}
  </motion.h1>

  <p className="counter-label">
    {stats[index].label}
  </p>
</div>
        </div>
      </section>

<section className="our-offerings-section">
  <h2 className="our-offerings-title">What We Offer</h2>
  <div className="offerings-grid">
    {/* Card 1 */}
    <div className="offering-card survey">
      <img src="/ESP_img.png" alt="Employee Survey Platform" />
      <h3>Employee Survey Platform</h3>
    </div>
    {/* Card 2 */}
    <div className="offering-card Certification">
      <img src="/assets/Badge_TM.png" alt="Outstanding Workplaces Certification" />
      <h3>Outstanding Workplaces Certification</h3>
    </div>
    {/* Card 3 */}
    <div className="offering-card standard">
      <img src="assets/standard.png" alt="Standard Certification" />
      <h3>The Standard Certification</h3>
      <ul>
        <li>Minimum 70% positive responses in Trust Index survey and comply with audit norms.</li>
        <li>Submit your company culture.</li>
      </ul>
    </div>
    {/* Card 4 */}
    <div className="offering-card criteria">
      <img src="/piechart.png" alt="Criteria for Outstanding Workplaces" />
      <h3>Criteria for Outstanding Workplaces recognize</h3>
      <ul>
        <li>Outstanding company cultures.</li>
        <li>Exceptional employee experiences.</li>
        <li>Best practices in the industry.</li>
      </ul>
    </div>
  </div>
</section>

      <RealStoriesSection />
      <section className="home-blue-section center-title-section">
  <h2 className="center-title">
    Building Outstanding Workplaces for All in Stronger India!
  </h2>
</section>

      <section className="nomination-section" ref={nominationRef}>
        <div className="nomination-left">
          <h2 className="nomination-title">Get ready to be certified as an Outstanding Workplaces!</h2>
          <p className="nomination-desc">
            Tell us a little about your company and someone from our team will be in touch soon.
          </p>
        </div>
        <form className="nomination-form white-bg-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>* First Name</label>
              <input name="firstName" type="text" placeholder="Enter your first name" value={form.firstName} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>* Last Name</label>
              <input name="lastName" type="text" placeholder="Enter your last name" value={form.lastName} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>* Role</label>
              <select name="role" value={form.role} onChange={handleChange} required>
                <option value="">-Select Role-</option>
                <option>Founder / CEO</option>
                <option>CHRO / Vice President</option>
                <option>Head HR</option>
                <option>HR / Training</option>
                <option>Marketing Team</option>
                <option>Talent Acquisition / Recruitment</option>
                <option>Executive Team</option>
                <option>Other</option>
              </select>
            </div>
            <div className="form-group">
              <label>* Work Email Address</label>
              <input
                name="email"
                type="email"
                placeholder="Enter your work email address"
                value={form.email}
                onChange={handleChange}
                required
                style={emailError ? { borderColor: "red" } : {}}
              />
              {emailError && (
                <div style={{ color: "red", fontSize: "0.95rem", marginTop: 4 }}>
                  {emailError}
                </div>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>* Mobile Number</label>
              <input name="mobile" type="text" placeholder="Enter your mobile number" value={form.mobile} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>* Type of Company</label>
              <select name="typeOfCompany" value={form.typeOfCompany} onChange={handleChange} required>
                <option value="">-Select-</option>
                <option>Proprietorship</option>
<option>Partnership</option>
<option>Limited Liability Partnership (LLP)</option>
<option>Private Limited (Pvt Ltd)</option>
<option>Public Limited</option>
<option>One Person Company (OPC)</option>
<option>Corporation</option>
<option>Non-Governmental Organization (NGO)</option>
<option>Educational Institution / University</option>
<option>Others</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>* Company Name</label>
              <input name="companyName" type="text" placeholder="Enter your Company Name" value={form.companyName} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>* Company's Headquarters</label>
              <select name="hq" value={form.hq} onChange={handleChange} required>
                <option value="">-Select -</option>
                <option>Andhra Pradesh</option>
                <option>Arunachal Pradesh</option>
                <option>Assam</option>
                <option>Bihar</option>
                <option>Chhattisgarh</option>
                <option>Goa</option>
                <option>Gujarat</option>
                <option>Haryana</option>
                <option>Himachal Pradesh</option>
                <option>Jharkhand</option>
                <option>Karnataka</option>
                <option>Kerala</option>
                <option>Madhya Pradesh</option>
                <option>Maharashtra</option>
                <option>Manipur</option>
                <option>Meghalaya</option>
                <option>Mizoram</option>
                <option>Nagaland</option>
                <option>Odisha</option>
                <option>Punjab</option>
                <option>Rajasthan</option>
                <option>Sikkim</option>
                <option>Tamil Nadu</option>
                <option>Telangana</option>
                <option>Tripura</option>
                <option>Uttar Pradesh</option>
                <option>Uttarakhand</option>
                <option>West Bengal</option>
                <option>Andaman & Nicobar Islands</option>
                <option>Chandigarh</option>
                <option>Dadra & Nagar Haveli and Daman & Diu</option>
                <option>Delhi</option>
                <option>Lakshadweep</option>
                <option>Puducherry</option>
                <option>Ladakh</option>
                <option>Jammu & Kashmir</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>* Industry</label>
              <select name="industry" value={form.industry} onChange={handleChange} required>
                <option value="">-Select Industry-</option>
                <option>Agriculture</option>
                <option>Automotive</option>
                <option>Banking & Financial Services (BFSI)</option>
                <option>Chemicals & Petrochemicals</option>
                <option>Construction & Infrastructure</option>
                <option>Consumer Goods & FMCG</option>
                <option>Education & Training</option>
                <option>Energy & Utilities</option>
                <option>Engineering & Industrial Manufacturing</option>
                <option>Environmental Services</option>
                <option>Food & Beverage</option>
                <option>Government & Public Sector</option>
                <option>Healthcare & Pharmaceuticals</option>
                <option>Hospitality & Tourism</option>
                <option>Information Technology (IT) & Software</option>
                <option>Insurance</option>
                <option>Logistics & Supply Chain</option>
                <option>Media & Entertainment</option>
                <option>Mining & Metals</option>
                <option>Manufacturing & Production</option>
                <option>Non-Profit & NGOs</option>
                <option>Oil & Gas</option>
                <option>Real Estate</option>
                <option>Retail & E-commerce</option>
                <option>Telecommunications</option>
                <option>Textiles & Apparel</option>
                <option>Transportation</option>
                <option>Research & Development (R&D)</option>
                <option>Aerospace & Defense</option>
                <option>Consulting & Professional Services</option>
                       <option>Others</option>
              </select>
              {/* <span className="header-arrow"></span> */}
            </div>
            <div className="form-group">
              <label>* Number of Employees</label>
              <select name="employees" value={form.employees} onChange={handleChange} required>
                <option value="">-Select-</option>
                <option>10 - 20</option>
                <option>21 - 50</option>
                <option>51 - 100</option>
                <option>101 - 200</option>
                <option>501 - 1000</option>
                <option>1001 - 3000</option>
                <option>3001 - 5000</option>
                <option>5001 - 10000</option>
                <option>Above 10000</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>* How did you come to know about us?</label>
              <select name="howDidYouKnow" value={form.howDidYouKnow} onChange={handleChange} required>
                <option value="">-Select-</option>
                <option>Google Search</option>
                <option>Social Media</option>
                <option>WhatsApp Group</option>
                <option>HR Community</option>
                <option>Referred by Others</option>
              </select>
            </div>
          </div>
          <div className="consent-checkbox" style={{ marginTop: '-2px' }}>
            <label>
              <input name="consent" type="checkbox" className="consent-checkbox" checked={form.consent} onChange={handleChange} required />You acknowledge that you've read and understood the <a href="/terms-and-conditions" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Terms and Conditions</a> and <a href="/privacy-policy" rel="noopener noreferrer"style={{ textDecoration: 'none' }}>Privacy Policy</a>.*
            </label>
          </div>
          <Button
  type="submit"
  variant="contained"
  sx={{
    fontWeight: 600,
    fontSize: '1.1rem',
    borderRadius: '8px',
    boxShadow: 'none',
    textTransform: 'none',
    padding: '10px 28px',
    backgroundColor: '#0b1d51',
    '&:hover': {
      backgroundColor: '#0b1d51',
    },
  }}
>
  SUBMIT
</Button>
        </form>
      </section>
    </>
  );
}

export default Home;